// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"529ebb9b","544":"d4139ab1","560":"97da580e"}[chunkId] + ".chunk.css";
};